import React from "react";
// import SmallCard from "./SmallCard"; // Assuming SmallCard is a separate component


const ToolsSection = ({
    title = "Tools",
    showAll,
    toggleView,
    cardData,
    selectedCard,
    handleCardClick,
    type
}) => {

    return (
        <div className="homepage-tools-sec-middlePart d-flex flex-column px-3">
            <div
                className="d-flex flex-row px-4"
                style={{ justifyContent: "space-between", paddingTop: "10px" }}
            >
                <p className="card-title-middle1">{title}</p>
                <p
                    className="card-title-middle2"
                    style={{
                        cursor: "pointer",
                        color: "#0044C6", // Optional: Make it look clickable
                    }}
                    onClick={toggleView}
                >
                    {showAll ? "View Less" : "View All"}
                </p>
            </div>

            <div
                className="px-3"
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                }}
            >
                {(showAll ? cardData : cardData.slice(0, 4)).map((name, index) => (
                    <SmallCards
                        key={index}
                        text={name}
                        isSelected={selectedCard === index}
                        onClick={() => handleCardClick(index, type)}
                    />
                ))}
            </div>
        </div>
    );
};

export default ToolsSection;

const SmallCards = ({ text, isSelected, onClick }) => {
    return (

        <div
            className='small-card mx-1 mb-2 mb-3 d-flex flex-column'
            onClick={onClick}
        >
            <img src={text.icon} alt="Image" />
            <span style={{ textAlign: "center", fontSize: "14px" }}>{text.name}</span>
        </div>
    );
};